import Param from "../../../param";
import Util from "../../libs/util";
import Force from "../util/force";

const param = new Param();
const util = new Util();
let force = new Force();

export default class MakeTexture {
    constructor(src){


        this.src = src;

        this.tex;
        this.texOther = [];


        this.maskTex ={
            x : [],
            y : ""
        };
        this.mesh;

        this.uniforms;


    }
    init(w,h,scene,no){

        let _this = this;

        for(let i=0; i<param.webgl.mainvisual.mask.src.length; i++){
            this.maskTex.x[i] = new THREE.TextureLoader().load(param.webgl.mainvisual.mask.src[i]);
        }

        this.maskTex.y = new THREE.TextureLoader().load(param.webgl.mainvisual.mask.srcY);
        let _src;
        // if(no==3){
        //     _src = this.src[0];

        //     for(let i=1; i<3; i++){
        //         this.texOther[i] = new THREE.TextureLoader().load(this.src[i]);
        //     }

        // }else{
            _src = this.src;
        // }

        this.tex = new THREE.TextureLoader().load(_src,function () {
            let _geo = new THREE.PlaneGeometry(1, 1, 32, 32);
            _geo.verticesNeedUpdate=true;
            _this.tex.needsUpdate = true;

            _this.uniforms = {
                // texture   :{value:no==3?_this.texOther[1]:_this.tex},
                texture   :{value:_this.tex},
                selectTex   :{value:0.0}, /* 選択しているテクチャー */
                tMask   :{value:_this.maskTex.x[Math.floor(util.random(0,2))]},
                tMaskY   :{value:_this.maskTex.y},
                strength   :{value:400.0},
                offsetX   :{value:0.0},
                offsetY   :{value:0.0},
                offMask   :{value:true},
                offMaskY   :{value:true},
                opacity   :{value:1.0},
                contrast   :{value:0.0},
                darkness   :{value:0.0},
                colorFilter   :{value:false},
                acceleration   :{value:0.1},
                radius : {type: "f", value: Math.PI/30},
                distort : {type: "f", value: 1},
                start : {type: "f", value: 1.0},
                // noiseMulti : {type: "f", value: 0.5},
                noiseMulti : {type: "f", value: 0.0},
                time : {type: "f", value: 1},
                resolution : { type: "v2", value: new THREE.Vector2() },
                mouse : { type: "v2", value: new THREE.Vector2() }
            }


            // if(no==3){
            //     // _this.uniforms["texture"] = {value:this.texOther[1] };
            //     // _this.uniforms["tOther2"] = {value:this.texOther[2] };
            // }


            _this.uniforms.contrast.value = 0.0;
            _this.uniforms.resolution.x = _this.tex.image.width;
            _this.uniforms.resolution.y = _this.tex.image.height;

            // _this.uniforms.resolution.x = w;
            // _this.uniforms.resolution.y = h;

            let _mat = new THREE.ShaderMaterial({
                vertexShader: require('../../../../shader/mainvisual.vert'),
                fragmentShader: require('../../../../shader/photo.frag'),
                uniforms:_this.uniforms
            });

            _this.mesh = new THREE.Mesh( _geo,_mat );

            if(no!==0) _this.mesh.position.x = w * 8;

            scene.add(_this.mesh);

        });



    }
    resize(w,h){
        _this.uniforms.resolution.x = w;
        _this.uniforms.resolution.y = h;

    }
}